import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {lastValueFrom} from "rxjs";
import {PreparationContainer} from "../../Model/dataProcess/PreparationContainer";

@Injectable()
export class PreparationContainerService {
  private readonly apiUrl = 'api/PreparationContainer';

  constructor(private http: HttpClient) {}

  public getPreparationContainer(customerId: string): Promise<PreparationContainer> {
    const url = `${this.apiUrl}/getPreparationContainer`;
    const params = new HttpParams()
      .append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<PreparationContainer>(url, options));
  }
  
  public async moveCatalog(catalogId: string, preparationContainerId: string, toArchive: boolean, customerId: string): Promise<PreparationContainer> {
    const url = `${this.apiUrl}/moveCatalog`;
    return lastValueFrom(this.http.post<PreparationContainer>(url, { catalogId, preparationContainerId, toArchive, customerId }));
  }

  public async removeCatalog(catalogId: string, preparationContainerId: string, customerId: string): Promise<PreparationContainer> {
    const url = `${this.apiUrl}/removeCatalog`;
    const params = new HttpParams()
      .append('catalogId', catalogId)
      .append('preparationContainerId', preparationContainerId)
      .append('customerId', customerId);
    return lastValueFrom(this.http.post<PreparationContainer>(url, null, { params }));
  }
}
